import axios from 'axios';
import Naluri from '~/common/api/naluri';
import { currentToken } from '~/common/auth';
import {
  MODULES_GET_MODULE_ANSWER_BEGIN,
  MODULES_GET_MODULE_ANSWER_DISMISS_ERROR,
  MODULES_GET_MODULE_ANSWER_FAILURE,
  MODULES_GET_MODULE_ANSWER_SUCCESS,
} from './constants';

// TODO: Request for all versions of answers to display
// history of all answers
export function getModuleAnswer(moduleId, userId) {
  return dispatch => {
    dispatch({
      type: MODULES_GET_MODULE_ANSWER_BEGIN,
    });

    return new Promise((resolve, reject) => {
      const promise =
        moduleId === 2024 // ewa-7
          ? getModuleAnswerBySlugAsync('wmhd2024-ewa-7', userId)
          : Naluri.get(`/api/expert/modules/${moduleId}/answers/${userId}`);

      promise.then(
        res => {
          dispatch({
            type: MODULES_GET_MODULE_ANSWER_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: MODULES_GET_MODULE_ANSWER_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });
  };
}

async function getModuleAnswerBySlugAsync(slug, userId) {
  const token = await currentToken();
  const res = await axios.get(
    `${process.env.NALURI_APP_COACH_PLATFORM_API_GATEWAY}/assessment/${slug}/answers/${userId}`,
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    },
  );
  if (res.status !== 200) {
    console.log('Error getting module answer by slug');
    return null;
  }
  return res.data;
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetModuleAnswerError() {
  return {
    type: MODULES_GET_MODULE_ANSWER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MODULES_GET_MODULE_ANSWER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getModuleAnswerPending: true,
        getModuleAnswerError: null,
      };

    case MODULES_GET_MODULE_ANSWER_SUCCESS:
      // The request is success
      return {
        ...state,
        answer: action.data,
        getModuleAnswerPending: false,
        getModuleAnswerError: null,
      };

    case MODULES_GET_MODULE_ANSWER_FAILURE:
      // The request is failed
      return {
        ...state,
        getModuleAnswerPending: false,
        getModuleAnswerError: action.data.error,
      };

    case MODULES_GET_MODULE_ANSWER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getModuleAnswerError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/modules/redux/getModuleAnswer.js